module.exports = __webpack_public_path__ + "img/bank_icon.078000bd.svg";